import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Button,
  Modal,
  Row,
  Col,
  Form,
  Container,
  Badge,
  ButtonGroup,
} from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import axios from "axios";

// Databale

import { FilterMatchMode } from "primereact/api";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Toolbar } from "primereact/toolbar";
import { Toast } from "primereact/toast";
import "primeicons/primeicons.css";

import "../../asset/style.css";

import { APIKEY } from "../../Config/Config";

class Navbar extends Component {
  constructor() {
    super();
    this.editor = React.createRef();
    this.state = {
      Navbardata: [],
      ID: "",
      tittle: '',
    navbarurl: '',
    Keyword: '',
    SeoMetaTitle: '',
    SeoMetaDescription: '',
    SeoMetaTags: '',
    navbarposition: '',
    SocialShareImage: '',
      status: null,
      show: false,
      fullscreen: true,
      Deletemodal: "",
      Statusmodal: "",
      // datatable
      filters1: null,
      globalFilterValue1: "",
      loading1: true,
      balanceFrozen: true,
    };
    this.onGlobalFilterChange1 = this.onGlobalFilterChange1.bind(this);
    this.activityBodyTemplate = this.activityBodyTemplate.bind(this);
    this.BlogStatus = this.BlogStatus.bind(this);
    this.leftToolbarTemplate = this.leftToolbarTemplate.bind(this);
    this.rightToolbarTemplate = this.rightToolbarTemplate.bind(this);
    this.exportCSV = this.exportCSV.bind(this);
    this.onChangeNavbar = this.onChangeNavbar.bind(this);
  }

  componentDidMount() {
    this.getAll();
    this.initFilters1();
  }

  getAll() {
    axios.get(`${APIKEY}/navbar/`).then((res) => {
      this.setState({
        Navbardata: res.data,
        loading1: false,
      });
      console.log("data", res.data);
    });
  }
  // Datatable Start
  onGlobalFilterChange1(e) {
    const value = e.target.value;
    let filters1 = { ...this.state.filters1 };
    filters1["global"].value = value;

    this.setState({ filters1, globalFilterValue1: value });
  }
  initFilters1() {
    this.setState({
      filters1: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      globalFilterValue1: "",
    });
  }

  renderHeader1() {
    return (
      <div className="flex justify-content-between">
        {/* <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={this.clearFilter1} /> */}
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            value={this.state.globalFilterValue1}
            onChange={this.onGlobalFilterChange1}
            placeholder="Keyword Search"
          />
        </span>
      </div>
    );
  }

  BlogStatus(rowData) {
    return (
      <>
        <div className="">
          {rowData.isActive ? (
            <>
              <h6>
                <Badge bg="success">Active</Badge>
              </h6>
            </>
          ) : (
            <>
              <h6>
                <Badge bg="danger">InActive</Badge>
              </h6>
            </>
          )}
        </div>
      </>
    );
  }
  activityBodyTemplate(rowData) {
    return (
      <>
        <div className="">
          <ButtonGroup aria-label="Basic example">
            <Button
              variant="primary"
              size="sm"
              data-toggle="tooltip"
              data-placement="left"
              title="Edit"
              onClick={() => this.EditClickButton(rowData)}
            >
              <Icon.PencilFill />
            </Button>{" "}
          
            <Button
              variant="danger"
              size="sm"
              data-toggle="tooltip"
              data-placement="left"
              title="Delete"
              onClick={() => this.DeleteClickButton(rowData._id)}
            >
              <Icon.TrashFill />
            </Button>{" "}
          </ButtonGroup>
        </div>
      </>
    );
  }
  exportCSV() {
    this.dt.exportCSV();
  }

  leftToolbarTemplate() {
    return (
      <React.Fragment>
        {/* <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={this.confirmDeleteSelected} disabled={!this.state.selectedProducts || !this.state.selectedProducts.length} /> */}
        <div>
          <h3>Navbar</h3>
        </div>
      </React.Fragment>
    );
  }

  rightToolbarTemplate() {
    return (
      <React.Fragment>
        {/* <FileUpload mode="basic" name="demo[]" auto url="https://primefaces.org/primereact/showcase/upload.php" accept=".csv" chooseLabel="Import" className="mr-2 inline-block" onUpload={this.importCSV} /> */}
        <Button
          label="Export"
          variant="warning"
          className=" bg-warning me-2 btn text-white"
          onClick={this.exportCSV}
        >
          Export
        </Button>
        <Button
          label="New"
          icon="pi pi-plus"
          className="p-button-success mr-2"
          onClick={this.handleShow}
        >
          <Icon.Plus /> Add Navbar{" "}
        </Button>
      </React.Fragment>
    );
  }
  // Datatable end

  // Edit Click Button Start
  EditClickButton = (rowData) => {
    if (rowData) {
      this.setState({
        ID: rowData._id,
        Keyword: rowData.Keyword,
        navbarposition: rowData.navbarposition,
        navbarurl: rowData.navbarurl,
        tittle: rowData.tittle,
        SeoMetaTitle: rowData.SeoMetaTitle,
        SeoMetaTags: rowData.SeoMetaTags,
        SeoMetaDescription: rowData.SeoMetaDescription,
        SocialShareImage: rowData.SocialShareImage,
        show: true,
      });
    }
  };
  // Edit Click Button End

  // Delete click button start
  DeleteClickButton = (id) => {
    if (id) {
      this.setState({
        ID: id,
        Deletemodal: true,
      });
    }
  };
  // Delete click button end

 
  // Delete click button end

  // Onchange
  onChangeNavbar = ({ target: { name, value } }) => {
    this.setState({
      [name]: value,
    });
    console.log("onchnage", value);
  };
  //
 

  onChangeSocialShareImage = async (e) => {
    const file = e.target.files[0];
    this.setState({
        SocialShareImage: file,
    });
  };

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, snapshot) {}

  handleShow = (event) => {
    this.setState({
      show: true,
    });
  };
  ModelClose = (event) => {
    this.setState({
        ID: "",
        tittle: '',
      navbarurl: '',
      Keyword: '',
      SeoMetaTitle: '',
      SeoMetaDescription: '',
      SeoMetaTags: '',
      navbarposition: '',
      SocialShareImage: '',
      status: null,
      show: false,
    });
  };

  DeleteModelClose = (event) => {
    this.setState({
      ID: "",
      Deletemodal: false,
    });
  };
  StatusModelClose = (event) => {
    this.setState({
      ID: "",
      status: "",
      Statusmodal: false,
    });
  };

  // Blog Submit
  NavbarSubmit = (event) => {
    event.preventDefault();
    if (this.state.ID) {
      this.EditNavbarSubmit(this.state.ID);
    } else {
      this.AddNavbarSubmit();
    }
  };

  AddNavbarSubmit = (event) => {
    const formData = new FormData();

    formData.append("tittle", this.state.tittle)
      formData.append("Keyword", this.state.Keyword)
      formData.append("navbarurl", this.state.navbarurl)
      formData.append("SeoMetaTitle", this.state.SeoMetaTitle)
      formData.append("SeoMetaDescription", this.state.SeoMetaDescription)
      formData.append("SeoMetaTags", this.state.SeoMetaTags)
      formData.append("navbarposition", this.state.navbarposition)
      formData.append("SocialShareImage", this.state.SocialShareImage)
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios
      .post(`${APIKEY}/navbar/`, formData, config)
      .then((res) => {
        if (res.data) {
          this.getAll();
          this.ModelClose();
          this.toast.show({
            severity: "success",
            summary: "Successfully",
            detail: "Navbar Created",
            life: 3000,
          });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  EditNavbarSubmit = (id) => {
    if (id) {
      const formData = new FormData();

      formData.append("tittle", this.state.tittle)
      formData.append("Keyword", this.state.Keyword)
      formData.append("navbarurl", this.state.navbarurl)
      formData.append("SeoMetaTitle", this.state.SeoMetaTitle)
      formData.append("SeoMetaDescription", this.state.SeoMetaDescription)
      formData.append("SeoMetaTags", this.state.SeoMetaTags)
      formData.append("navbarposition", this.state.navbarposition)
      formData.append("SocialShareImage", this.state.SocialShareImage)
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      axios
        .put(`${APIKEY}/navbar/${id}/`, formData, config)
        .then((res) => {
          if (res.data) {
            console.log("Update okkk");
            this.getAll();
            this.ModelClose();
            this.toast.show({
              severity: "success",
              summary: "Update Successful",
              detail: "Navbar Updated ",
              life: 3000,
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };
  // Delete Blog Data
  DeleteNavbardata = (event) => {
    if (this.state.ID) {
      axios.delete(`${APIKEY}/navbar/delete/${this.state.ID}/`).then((res) => {
        if(res.data){
          console.log("data", res.data);
          this.getAll();
          this.setState({
            Deletemodal: false,
          });
          this.toast.show({
            severity: "success",
            summary: "Successfully",
            detail: "Navbar Deleted",
            life: 3000,
          });
        }
       
      }).catch((e) => {
        console.log(e);
      });
    }
  };
  // Blog Status Submit
  // Blog Status Submit
  StatusSubmit = (event) => {
    if (this.state.ID) {
      event.preventDefault();
      const formData = new FormData();
      formData.append("isActive", this.state.status);
      console.log(this.state.status, "this.state.status");
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      axios
        .put(`${APIKEY}/Blog/status/${this.state.ID}/`, formData, config)
        .then((res) => {
          if (res.data) {
            console.log("Update okkk");
            this.getAll();
            this.StatusModelClose();
            this.toast.show({
              severity: "success",
              summary: "Successful",
              detail: "Blog Status",
              life: 3000,
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  render() {
    const header1 = this.renderHeader1();

    return (
      <>
        <div className="container-fluid">
          <Toast ref={(el) => (this.toast = el)} />

          {/* Modal */}
          <Modal
            show={this.state.show}
            fullscreen={this.state.fullscreen}
            onHide={this.ModelClose}
          >
            <Modal.Header closeButton>
              <Modal.Title>Add Navbar</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                <Container>
                  <Form onSubmit={this.NavbarSubmit}>
                    <Row>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Navbar Tittle</Form.Label>
                          <Form.Control
                            type="text"
                            name="tittle"
                            value={this.state.tittle}
                            onChange={this.onChangeNavbar}
                            placeholder=""
                            required
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Navbar url</Form.Label>
                          <Form.Control
                            type="text"
                            name="navbarurl"
                            value={this.state.navbarurl}
                            onChange={this.onChangeNavbar}
                            placeholder=""
                            required
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Keyword</Form.Label>
                          <Form.Control
                            type="text"
                            name="Keyword"
                            value={this.state.Keyword}
                            onChange={this.onChangeNavbar}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>

                     

                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Seo Meta Title</Form.Label>
                          <Form.Control
                            type="text"
                            name="SeoMetaTitle"
                            value={this.state.SeoMetaTitle}
                            onChange={this.onChangeNavbar}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Seo Meta Description</Form.Label>
                          <Form.Control
                            type="text"
                            name="SeoMetaDescription"
                            value={this.state.SeoMetaDescription}
                            onChange={this.onChangeNavbar}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Seo Meta Tags</Form.Label>
                          <Form.Control
                            type="text"
                            name="SeoMetaTags"
                            value={this.state.SeoMetaTags}
                            onChange={this.onChangeNavbar}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>navbar position</Form.Label>
                          <Form.Control
                            type="number"
                            min="0"
                            name="navbarposition"
                            value={this.state.navbarposition}
                            onChange={this.onChangeNavbar}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>

                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Social Share Image</Form.Label>
                          <Form.Control
                            type="file"
                            name="SocialShareImage"
                            onChange={this.onChangeSocialShareImage}
                            placeholder=""
                          />
                        </Form.Group>
                        {this.state.ID && this.state.SocialShareImage ? (
                          <>
                            <img
                              src={`${APIKEY}/Blog_image/${this.state.SocialShareImage}/`}
                              className="rounded"
                              width={100}
                            />
                            <Button variant="danger">
                              <Icon.TrashFill />
                            </Button>
                          </>
                        ) : null}
                      </Col>
                    </Row>

                    <Row>
                      <div className="d-flex justify-content-end">
                        <br></br>
                        <Button
                          variant="danger"
                          className="me-2"
                          onClick={this.ModelClose}
                        >
                          Cancel
                        </Button>
                        <Button variant="primary" type="submit">
                          {this.state.ID ? "Update" : "Submit"}
                        </Button>
                      </div>
                    </Row>
                  </Form>
                </Container>
              </div>
            </Modal.Body>
          </Modal>
          {/* Modal end */}
          <div>
            {/* Datatable start*/}

            <Toolbar
              className="mb-4"
              left={this.leftToolbarTemplate}
              right={this.rightToolbarTemplate}
            ></Toolbar>

            <DataTable
              value={this.state.Navbardata}
              ref={(el) => (this.dt = el)}
              size="small"
              paginator
              scrollable
              scrollHeight="400px"
              className="p-datatable-customers"
              showGridlines
              rows={10}
              dataKey="id"
              filters={this.state.filters1}
              filterDisplay="menu"
              loading={this.state.loading1}
              responsiveLayout="scroll"
              globalFilterFields={["navbarurl","tittle"]}
              header={header1}
              emptyMessage="No Navbar found."
            >
              <Column
                field="navbarurl"
                header="Navbar URL"
                alignFrozen="left"
                frozen={this.state.balanceFrozen}
                style={{ minWidth: "12rem" }}
              />
              <Column
                field="tittle"
                header="Tittle"
                style={{ minWidth: "0px " }}
              />
              <Column
                field="navbarposition"
                header="navbar position"
                style={{ minWidth: "0px " }}
              />
              <Column
                field="SeoMetaTitle"
                header="SeoMeta Title"
                style={{ minWidth: "0px " }}
              />
           

              <Column
                field="Action"
                header="Action"
                showFilterMatchModes={false}
                alignFrozen="right"
                frozen={this.state.balanceFrozen}
                style={{ minWidth: "6rem" }}
                body={this.activityBodyTemplate}
              />
            </DataTable>
            {/* Datatable end*/}

            {/* Delete data modal start */}
            <Modal
              show={this.state.Deletemodal}
              onHide={this.DeleteModelClose}
              size="md"
              aria-labelledby="contained-modal-title-vcenter"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                  Delete
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <h4>Do you want delete this data ?</h4>
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={this.DeleteModelClose}>No</Button>
                <Button variant="danger" onClick={this.DeleteNavbardata}>
                  Yes
                </Button>
              </Modal.Footer>
            </Modal>
            {/* Delete data modal end */}
            {/* Status data modal start */}
            <Modal
              show={this.state.Statusmodal}
              onHide={this.StatusModelClose}
              size="md"
              aria-labelledby="contained-modal-title-vcenter"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                  Status
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form onSubmit={this.StatusSubmit}>
                  <Row>
                    <Col md={12}>
                      <Form.Group as={Row} className="mb-3">
                        <Form.Label as="legend" column sm={2}>
                          Status
                        </Form.Label>
                        <Col sm={10}>
                          <Form.Check
                            type="radio"
                            label="Active"
                            name="status"
                            value={true}
                            onChange={this.onChangeNavbar}
                            id="formHorizontalRadios1"
                          />
                          <Form.Check
                            type="radio"
                            label="Inactive"
                            name="status"
                            value={false}
                            onChange={this.onChangeNavbar}
                            id="formHorizontalRadios2"
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <div className="d-flex justify-content-end">
                      <br></br>

                      <Button
                        variant="danger"
                        className="me-2"
                        onClick={this.StatusModelClose}
                      >
                        Cancel
                      </Button>
                      <Button variant="primary" type="submit">
                        Submit
                      </Button>
                    </div>
                  </Row>
                </Form>
              </Modal.Body>
            </Modal>
            {/* Status data modal end */}
          </div>
        </div>
      </>
    );
  }
}
export default Navbar;
